import { Button, Tooltip } from "antd";
import { useEffect, useState } from "react";
import useCheckModule from "../hooks/useCheckModule";
import { useTenantStore } from "../stores/tenantStore";
import { GetAntIcon } from "../utils/ant_icons";
import { noSubscriptionMessage } from "./LockedModuleTooltip";

interface AuditLogButtonProps {
	handleClick: () => void;
	moduleKey?: string;
}

function AuditLogButton({ handleClick, moduleKey }: AuditLogButtonProps) {
	const currentTenant = useTenantStore((state) => state.tenant);

	const { checkModule } = useCheckModule();

	const [isEnabled, setIsEnabled] = useState(
		moduleKey ? checkModule(moduleKey) : true
	);

	useEffect(() => {
		if (moduleKey) {
			setIsEnabled(checkModule(moduleKey));
		}
	}, [currentTenant]);

	return (
		<Tooltip
			title={!isEnabled ? noSubscriptionMessage : undefined}
			placement={"right"}
		>
			<Button
				className="audit-log-button"
				type="link"
				icon={GetAntIcon("history")}
				onClick={handleClick}
				disabled={!isEnabled}
			>
				Audit log
			</Button>
		</Tooltip>
	);
}

export default AuditLogButton;
